
import Button from '../../../components/base/Button';

export default function HeroSection() {
  const scrollToBooking = () => {
    const element = document.getElementById('booking');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const openChat = () => {
    const widget = document.querySelector('#vapi-widget-floating-button') as HTMLElement;
    if (widget) {
      widget.click();
    }
  };

  return (
    <section 
      id="home" 
      className="relative min-h-screen flex items-center bg-cover bg-center bg-no-repeat"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url('https://public.readdy.ai/ai/img_res/cd145793db5eb344aaa1c80c0db417a9.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="max-w-2xl">
          <h1 className="text-4xl md:text-6xl font-bold text-white mb-6 leading-tight">
            Professional Home Cleaning Services
          </h1>
          <p className="text-xl text-gray-200 mb-8 leading-relaxed">
            Transform your home with our reliable, thorough, and eco-friendly cleaning services. 
            More time for what matters most to you.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Button 
              onClick={scrollToBooking}
              size="lg"
              className="bg-blue-600 hover:bg-blue-700"
            >
              <i className="ri-calendar-check-line mr-2"></i>
              Book Your Cleaning
            </Button>
            <Button 
              onClick={openChat}
              variant="outline"
              size="lg"
              className="border-white text-white hover:bg-white hover:text-gray-900"
            >
              <i className="ri-phone-line mr-2"></i>
              Get Free Quote
            </Button>
          </div>
          
          <div className="mt-12 grid grid-cols-3 gap-8 text-white">
            <div className="text-center">
              <div className="text-2xl font-bold">500+</div>
              <div className="text-sm text-gray-300">Happy Customers</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold">5★</div>
              <div className="text-sm text-gray-300">Average Rating</div>
            </div>
            <div className="text-center">
              <div className="text-2xl font-bold">24/7</div>
              <div className="text-sm text-gray-300">Support</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
